export const emailSchema = {
  required: 'Email is required',
  pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: 'Invalid email address' }
};

export const passwordSchema = {
  required: 'Password is required',
  minLength: { value: 8, message: 'Password must be at least 8 characters' }
};

export const confirmPasswordSchema = {
  required: 'Confirm Password is required',
  minLength: { value: 8, message: 'Password must be at least 8 characters' }
};

export const firstNameSchema = {
  required: 'First name is required',
  pattern: { value: /^[a-zA-Z\s]+$/, message: 'Invalid first name' }
};

export const lastNameSchema = {
  required: 'Last name is required',
  pattern: { value: /^[a-zA-Z\s]+$/, message: 'Invalid last name' }
};

export const restaurantNameSchema = {
  required: 'Restaurant name is required',
  minLength: { value: 2, message: 'Name is too short' }
};

export const addressSchema = {
  required: 'Address is required'
};

export const phoneSchema = {
  required: 'Phone number is required',
  pattern: { value: /^\+?[0-9\s-]{7,15}$/, message: 'Invalid phone number format' }
};

export const timeSchema = {
  required: 'Time is required'
};

// hooks/usePasswordStrength.js
export const usePasswordStrength = (password = "") => {
  return [
    { label: '8+ characters', met: password.length >= 8 },
    { label: 'Uppercase', met: /[A-Z]/.test(password) },
    { label: 'Number', met: /\d/.test(password) },
    { label: 'Special symbol', met: /[@$!%*?&]/.test(password) },
  ];
};
// utils/validations.js

export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

// utils/validations.js
export const passwordValidationRules = (t, isEdit = false) => ({
  // Only required if NOT in edit mode
  required: isEdit ? false : t('validation.passwordRequired'),
  
  minLength: {
    value: 8,
    message: t('validation.passwordTooShort')
  },
  pattern: {
    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    message: t('validation.passwordComplexity')
  }
});

export const phoneValidation = (t, min = 10, max = 15) => ({
  required: t('validation.required'),
  minLength: { value: min, message: t('validation.tooShort') },
  maxLength: { value: max, message: t('validation.tooLong') },
  pattern: { value: /^[0-9]+$/, message: t('validation.digitsOnly') }
});